import { useAppStore } from "./store";
import { UserRoles } from "./enums";

export const storageApi = {
  useGetUser() {
    return useAppStore((state) => state.user);
  },
  useGetUserToken() {
    return useAppStore((state) => state.user.accessToken);
  },
  useGetUserRole() {
    const role = useAppStore((state) => state.user.role);
    return {
      role,
      isSazman: UserRoles.Sazman,
      isSazmanOstan: UserRoles.SazmanOstan,
      isModireKol: UserRoles.ModireKol,
      isAdmin: UserRoles.Admin,
      isCustomer: role === UserRoles.User,
    };
  },
  getUserToken() {
    return useAppStore.getState().user.accessToken;
  },
  logout() {
    return useAppStore.getState().logoutUser;
  },
  useIsUserLogin() {
    const { accessToken } = useAppStore((state) => state.user);
    return !!accessToken;
  },
  useLogin() {
    return useAppStore((state) => state.loginUser);
  },
  useLogout() {
    return useAppStore((state) => state.logoutUser);
  },
};
